import React from 'react';
import Content from '../Content/Content';
import ScrollAnimation from 'react-animate-on-scroll';
import Grid from '../Grid-View/Grid-View';
import rest from './stable.jpg';

const Okolica = () => {
    return (
        <Content>
            <div>
                <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                    <h1 style={{marginBottom: '3em'}}>Okolica</h1>
                </ScrollAnimation>
                <Grid strona="lewa" zdj={rest}><p>Willa Stara Wozownia w Lusowie to wyjątkowe miejsce dla osób poszukujących kameralnej atmosfery, oryginalnego stylu wnętrz, ciszy, spokoju i relaksu. Mimo, że nie jesteśmy w centrum Poznania, nasza lokalizacja jest optymalna dla podróżujących zarówno w celach biznesowych jak i dla wypoczynku. 
Z lotniska Ławica dojazd zajmuje 15 minut (8,5 km), z centrum Poznania 30 minut. 
<br/>
Hotel jest idealnym miejscem zarówno na odpoczynek po dniu pełnym spotkań jak i na romantyczne wakacje.Bliskość jeziora lusowskiego i lasu zachęcają do spędzenia tutaj przyjemnych chwil z dala od zgiełku miasta, a jednoczesna bliskość Poznania to atut tego miejsca. 
Tuż za hotelem mieści się stajnia i klub jeździecki Hubertus.</p></Grid>
            </div>
        </Content>
    )
}

export default Okolica;


// WEBPACK FOOTER //
// ./src/okolica/okolica.js